export default __webpack_public_path__ + "28b9ce742b5753d7ee5089b9dfa0738e.png";